/**
 * Refonte Achats · Stock WP-13 (A-11) — a query into tokens: every token must match (AND), in any
 * order, each as a substring of any field (00_SPEC §H).
 */
import { normaliserRecherche, compacterRecherche } from "./normalise.js";
import { RECHERCHE_MIN_CARACTERES, RECHERCHE_MAX_TOKENS } from "./constantes.js";

/**
 * @param {unknown} requete  what the user typed (or scanned)
 * @param {{ maxTokens?: number, minCaracteres?: number }} [opts]
 * @returns {{
 *   texte: string,          normalised query
 *   compact: string,        normalised query without spaces (exact code / N° ENR comparison)
 *   tokens: string[],       distinct tokens, in typed order (ranking reads the first one)
 *   filtre: string[],       the tokens the matcher must test: a token contained in another one is
 *                           implied by it and dropped; longest first (most selective)
 *   valide: boolean         false below the minimum length (no search runs)
 * }}
 */
export function preparerRequete(requete, { maxTokens = RECHERCHE_MAX_TOKENS, minCaracteres = RECHERCHE_MIN_CARACTERES } = {}) {
  const texte = normaliserRecherche(requete);
  const compact = compacterRecherche(requete);
  const tokens = [];
  for (const t of texte ? texte.split(" ") : []) {
    if (!tokens.includes(t)) tokens.push(t);
    if (tokens.length >= maxTokens) break;
  }
  const filtre = tokens
    .filter((t, i) => !tokens.some((u, j) => j !== i && u.length > t.length && u.includes(t)))
    .sort((a, b) => b.length - a.length || (a < b ? -1 : a > b ? 1 : 0));
  return { texte, compact, tokens, filtre, valide: compact.length >= minCaracteres };
}
